import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Loader2, Lock } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

// Aviso de sesión caducada: se reingresa la contraseña sin salir de la pantalla actual (no se pierde lo cargado).
export const SesionVencidaDialog = () => {
  const { avisoSesionVencida, emailSesion, reautenticar, salirSesionVencida } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const email = emailSesion();

  const continuar = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setError('');
    const r = await reautenticar(password);
    setEnviando(false);
    if (!r.success) { setError(r.error); return; }
    setPassword('');
    toast.success('Sesión renovada. Podés continuar donde estabas.');
  };

  const otraCuenta = () => {
    const portal = location.pathname.startsWith('/portal');
    sessionStorage.setItem('freshen_motivo_login', 'sesion-vencida'); // la ruta protegida también puede redirigir
    navigate(portal ? '/portal/login' : '/login', {
      replace: true,
      state: { motivo: 'sesion-vencida', from: { pathname: location.pathname, search: location.search, hash: location.hash } },
    });
    salirSesionVencida();
    setPassword('');
  };

  return (
    <Dialog open={avisoSesionVencida && !!email}>
      <DialogContent className="max-w-md [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()} data-testid="sesion-vencida-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Lock className="h-5 w-5 text-amber-600" /> Tu sesión caducó</DialogTitle>
          <DialogDescription>
            Por seguridad la sesión se cerró tras un período sin actividad. Ingresá tu contraseña para continuar:
            lo que estabas cargando no se perdió y los envíos pendientes se completan solos.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={continuar} className="space-y-3">
          {error && (
            <Alert variant="destructive" data-testid="sesion-vencida-error"><AlertDescription>{error}</AlertDescription></Alert>
          )}
          <div className="space-y-1">
            <Label>Usuario</Label>
            <Input value={email} disabled data-testid="sesion-vencida-email" />
          </div>
          <div className="space-y-1">
            <Label htmlFor="sesion-vencida-password">Contraseña</Label>
            <Input id="sesion-vencida-password" type="password" autoFocus required value={password}
              onChange={(e) => setPassword(e.target.value)} data-testid="sesion-vencida-password" />
          </div>
          <div className="flex items-center justify-between gap-2 pt-1">
            <Button type="button" variant="ghost" size="sm" onClick={otraCuenta} data-testid="sesion-vencida-otra-cuenta">
              Ingresar con otra cuenta
            </Button>
            <Button type="submit" disabled={enviando || !password} data-testid="sesion-vencida-continuar">
              {enviando && <Loader2 className="h-4 w-4 mr-1 animate-spin" />} Continuar
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
